<template>
  <div class="h3c-header-ad">
    <img
      src="../../../../assets/images/closeAd.png"
      alt=""
      class="ad-close-btn"
      @click="handleClickClose"
    />
    <div class="ad-center">
      <div class="ad-text">
        9:00 AM on June 9(UTC/GMT+08:00), let's set sail for a better digital future
      </div>
      <div class="qr-code-wrapper fs-16" v-click-outside="handleClickOutside">
        <div class="btn-go" v-if="getTime()" @click="goToLive('5', '全体大会')">Watch Live</div>
        <div class="btn-go" v-else-if="handleEndTime()" @click="goToLive('5', '全体大会')">
          Playback
        </div>
        <!--     @click="handleClickFollow"   -->
        <span class="btn-go" v-else-if="scheduleDisable" @click="goToLive('5', '全体大会')"
          >Register now</span
        >
        <span class="btn-gray" @click="goToLive('5', '全体大会')" v-else>Reserved</span>
        <!--        <div class="qr-code" v-if="showQrcode">-->
        <!--          &lt;!&ndash;          <div class="img-code">/&ndash;&gt;-->
        <!--          <img-->
        <!--            class="qrCode-img"-->
        <!--            src="../../../../assets/images/headImg.png"-->
        <!--            style="width: 80px; height: 80px; border: 2px solid #fff"-->
        <!--          />-->
        <!--          <div class="showQrcode-text">扫码关注服务号</div>-->
        <!--        </div>-->
      </div>
    </div>
    <!--  鉴权二英文版 -->
    <!-- <authentication-one
      v-model:visible="isModalVisible"
      @update:visible="handleModalVisibleChange"
      :event-info="eventInfo"
    /> -->
  </div>
</template>

<script>
import { reactive, toRefs, ref, getCurrentInstance, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'
import { getMakeStatus } from '@/service/api/pc'
// import authenticationOne from '../../components/authenticationOne'
// import { Popover } from 'ant-design-vue'
export default {
  name: 'h3cHeaderAd',
  // components: { authenticationOne },
  setup(_, context) {
    const { proxy } = getCurrentInstance()
    const store = useStore()
    const h3cUser = store.getters['userStore/getUser']
    const isModalVisible = ref(false)
    const showQrcode = ref(false)
    const state = reactive({
      scheduleDisable: true
    })
    // const handleModalVisibleChange = (visible) => {
    //   isModalVisible.value = visible
    // }
    watch(
      () => store.state.userStore.user.id,
      (value) => {
        if (value) {
          getMakeStatus({
            phone: h3cUser.phone,
            scheduleId: '5',
            userId: h3cUser.id
          }).then((res) => {
            console.log('res', res)
            state.scheduleDisable = res.data
          })
        } else {
          state.scheduleDisable = true
        }
      },
      { deep: true }
    )
    onBeforeMount(() => {
      if (store.state.userStore.user.id) {
        getMakeStatus({
          phone: h3cUser.phone,
          scheduleId: '5',
          userId: h3cUser.id
        }).then((res) => {
          state.scheduleDisable = res.data
        })
      } else {
        state.scheduleDisable = true
      }
    })
    // 开始时间处理 观看直播场景
    const getTime = () => {
      // '2023-05-31T15:00:00' '2023-05-31T17:30:00'
      // '2023-06-09T09:00:00' '2023-06-09T11:30:00'
      // '2023-05-31T11:00:00'
      let startTime = '2023-06-09T09:00:00'
      let endTime = '2023-06-09T11:30:00'
      // 获取开始时间戳
      let starttamp = Date.parse(startTime)
      // 获取结束时间戳
      let endtamp = Date.parse(endTime)
      // 获取当前时间戳 或者 new Date().getTime()
      let current_timestamp = Date.now()
      // 当前时间大于开始时间并且当前时间小于结束时间，则表示直播已经开始
      if (current_timestamp >= starttamp && current_timestamp <= endtamp) {
        // todo 打开直播间 需要拿到直播间id跳转直播间
        // window.open('https://www.h3c.com/cn/', '_blank')
        return true
      } else {
        return false
      }
    }
    // 结束时间处理， 观看回放场景
    const handleEndTime = () => {
      // '2023-05-31T17:30:00' '2023-06-09T11:30:00' '2023-05-31T12:30:00'
      let endTime = '2023-06-09T11:30:00'
      // 结束时间的时间戳
      let endtamp = Date.parse(endTime)
      // 获取当前时间戳 或者 new Date().getTime()
      let current_timestamp = Date.now()
      // 当前时间大于等于结束时间，则表示直播已经结束
      if (current_timestamp > endtamp) {
        return true
      } else {
        return false
      }
    }
    return {
      getTime,
      handleEndTime,
      showQrcode,
      isModalVisible,
      ...toRefs(state),
      // handleModalVisibleChange,
      goToLive() {
        //   todo 观看直播+观看回放 跳转当前数据的直播间
        // window.open(
        //   process.env.VUE_APP_BASE_URL + process.env.VUE_APP_PUBLIC_PATCH + `session/${id}`,
        //   '_self'
        // )
        window.open(
          process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_PUBLIC_PATCH +
            `session/` +
            process.env.VUE_APP_QUANTI_ID,
          '_blank'
        )
      },
      handleClickClose() {
        context.emit('closeAd')
      },
      handleClickOutside() {
        showQrcode.value && (showQrcode.value = false)
      },
      handleClickFollow() {
        proxy.$bus.emit('openAuthenticationOne', true)
        showQrcode.value = !showQrcode.value
        // handleModalVisibleChange(true)
        window._gsq.push([
          'track',
          'Navigation',
          { page_name: '峰会网页', button_name: '关注服务号' }
        ])
      }
    }
  }
}
</script>

<style lang="less" scoped>
.h3c-header-ad {
  position: relative;
  height: 96px;
  width: 100%;
  background-image: url('../../../../assets/images/headerAd1-EN.png');
  background-size: 100% 100%;

  .ad-close-btn {
    cursor: pointer;
    width: 32px;
    height: 32px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.ad-center {
  position: relative;
  width: 1200px; /* no-pxtorem */
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 40px;
  color: #ffffff;
  .ad-text {
    font-size: 24px;
  }
  .qr-code-wrapper {
    position: relative;
    .btn-go {
      background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
      padding: 12px 28px;
      cursor: pointer;
      //width: 120px;
      height: 48px;
    }
    .btn-gray {
      background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
      //background-image: linear-gradient(135deg, #e3e3e3, #bebebe);
      color: #ffffff;
      padding: 12px 28px;
      width: 120px;
      height: 48px;
      cursor: pointer;
      //opacity: 0.65; /* 降低不透明度 */
      //cursor: not-allowed; /* 光标变为无效符号 */
      //pointer-events: none; /* 禁止用户触发事件 */
    }
    .qr-code {
      position: absolute;
      width: 145px;
      //bottom: -168px;
      //width: 150px;
      //height: 160px;
      //left: 14px;
      background-image: url('../../../../assets/images/head-ma.png');
      background-size: cover;
      z-index: 11;
      top: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 20px 18px;
    }
    .qrCode-img {
      margin-top: 5px;
    }
    .showQrcode-text {
      margin-top: 5px;
      font-size: 8px;
      color: #4c4948;
    }
  }
}
</style>
